import React from 'react';

import { H1, Span } from 'common/ui/Text';
import styles from 'css-module/components/www/_PricingV4.module.scss';

import PricingV4AutopilotCard from './PricingV4AutopilotCard';
import PricingV4TimeframeToggle from './PricingV4TimeframeToggle';

import type { Timeframe } from './Timeframe';

type Props = {
  timeframe: Timeframe;
  setTimeframe: (timeframe: Timeframe) => void;
};
export default function PricingV4Header({ timeframe, setTimeframe }: Props) {
  return (
    <div className={styles.pricingV4Header}>
      <div className={styles.headerLeft}>
        <Headline />
        <PricingV4TimeframeToggle timeframe={timeframe} setTimeframe={setTimeframe} />
      </div>
      <PricingV4AutopilotCard />
    </div>
  );
}

function Headline() {
  return (
    <div className={styles.headline}>
      <H1 className={styles.headlineTitle} variant="heading4Xl">
        Canny costs less than building the wrong&nbsp;features
      </H1>
      <Span className={styles.headlineSubtitle}>
        Start free and see what you <Span className={styles.headerItalics}>should</Span> be
        working&nbsp;on
      </Span>
    </div>
  );
}
